import { Trans, useTranslation } from "next-i18next";

import styles from "./PartnerInformation.module.scss";

interface PartnerInformationProps {
  name?: string;
}

export const PartnerInformation = ({ name }: PartnerInformationProps) => {
  const { t } = useTranslation("translations");

  return (
    <p className={styles.partner}>
      <Trans
        t={t}
        i18nKey="web_subscription_partner_subscription_info_one"
        parent="span"
        values={{ name: `<bold>${name}</bold>` }}
        components={{
          bold: <strong />,
        }}
      />
      <Trans
        t={t}
        i18nKey="web_subscription_partner_subscription_info_two"
        parent="span"
        values={{ name: `<bold>${name}</bold>` }}
        components={{
          bold: <strong />,
        }}
      />
    </p>
  );
};

export default PartnerInformation;
